module.exports = __webpack_public_path__ + "933d2b3fe782f9edf3a52c66043d577e.svg";